export const UPDATE_UTILS = '@@app/UPDATE_UTILS';
export const SET_ALERT = '@@app/SET_ALERT';
export const SET_MODAL = '@@app/SET_MODAL';
export const SET_ROUTE = '@@app/SET_ROUTE';
